export class PnlDataModel {
    public pnlText: string = ''; 
    public pnLColor: string = '';
   
    constructor(pnlData?: any) {
        if (pnlData) {
            this.pnlText = pnlData.pnLText;
            this.pnLColor = pnlData.pnLColor;
        }
    }

    public hasValue() : boolean{
        return !!this.pnlText;
    }

    public doesNotHaveValue() : boolean{
        return !this.hasValue();
    }
}
